export enum AppLink {
  NetworkInfrastructureMap,
  NetworkInventoryGateway,
}
